import {BaseContainerModel} from '../base-container.model';
import {bl_fi_mst_branch_location_link_RowClass} from '../../dbschema';

export class BranchLocationLinkContainerModel extends BaseContainerModel {
  bl_fi_mst_branch_location_link: bl_fi_mst_branch_location_link_RowClass = new bl_fi_mst_branch_location_link_RowClass();
}
